var map = {
	"./Dashboard/Account/AccountEdit": [
		42604,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		9245,
		3215,
		8607,
		2981,
		2604
	],
	"./Dashboard/Account/AccountEdit.js": [
		42604,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		9245,
		3215,
		8607,
		2981,
		2604
	],
	"./Dashboard/Account/AccountList": [
		35217,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3074,
		9245,
		3215,
		8607,
		2981,
		4174
	],
	"./Dashboard/Account/AccountList.js": [
		35217,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3074,
		9245,
		3215,
		8607,
		2981,
		4174
	],
	"./Dashboard/Index/Home": [
		3480,
		9,
		3480
	],
	"./Dashboard/Index/Home.js": [
		3480,
		9,
		3480
	],
	"./Dashboard/Setting/CodeFirst": [
		47769,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		7769
	],
	"./Dashboard/Setting/CodeFirst.js": [
		47769,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		7769
	],
	"./Dashboard/Setting/CodeSecond": [
		1814,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1814
	],
	"./Dashboard/Setting/CodeSecond.js": [
		1814,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1814
	],
	"./Dashboard/Setting/ControlList": [
		91521,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		1521
	],
	"./Dashboard/Setting/ControlList.js": [
		91521,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		1521
	],
	"./Dashboard/Setting/CreateEnvironFirst": [
		63323,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3323
	],
	"./Dashboard/Setting/CreateEnvironFirst.js": [
		63323,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3323
	],
	"./Dashboard/Setting/CreateEnvironSecond": [
		71959,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2692
	],
	"./Dashboard/Setting/CreateEnvironSecond.js": [
		71959,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2692
	],
	"./Dashboard/Setting/CurrencySettingFirst": [
		63790,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		3790
	],
	"./Dashboard/Setting/CurrencySettingFirst.js": [
		63790,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		3790
	],
	"./Dashboard/Setting/CustomerCodeFirst": [
		76619,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		6619
	],
	"./Dashboard/Setting/CustomerCodeFirst.js": [
		76619,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		6619
	],
	"./Dashboard/Setting/CustomerCodeSecond": [
		4735,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		9245,
		3215,
		8607,
		4735
	],
	"./Dashboard/Setting/CustomerCodeSecond.js": [
		4735,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		9245,
		3215,
		8607,
		4735
	],
	"./Dashboard/Setting/GroupPagesFirst": [
		91450,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1450
	],
	"./Dashboard/Setting/GroupPagesFirst.js": [
		91450,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1450
	],
	"./Dashboard/Setting/GroupPagesSecond": [
		11146,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1146
	],
	"./Dashboard/Setting/GroupPagesSecond.js": [
		11146,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1146
	],
	"./Dashboard/Setting/SystemSetting": [
		26364,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		8881,
		7606,
		9245,
		3215,
		8607,
		5111
	],
	"./Dashboard/Setting/SystemSetting.js": [
		26364,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		8881,
		7606,
		9245,
		3215,
		8607,
		5111
	],
	"./Dashboard/Setting/SystemStyle": [
		15236,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		7606,
		2112,
		8987,
		2521,
		8607,
		2981,
		5236
	],
	"./Dashboard/Setting/SystemStyle.js": [
		15236,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		7606,
		2112,
		8987,
		2521,
		8607,
		2981,
		5236
	],
	"./Dashboard/Setting/TaxSettingFirst": [
		14478,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		4478
	],
	"./Dashboard/Setting/TaxSettingFirst.js": [
		14478,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		4478
	],
	"./Dashboard/Setting/UnitSettingFirst": [
		11946,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1946
	],
	"./Dashboard/Setting/UnitSettingFirst.js": [
		11946,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		9245,
		3215,
		8607,
		1946
	],
	"./Dashboard/SysPermission/SysPermissionFirst": [
		10598,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		598
	],
	"./Dashboard/SysPermission/SysPermissionFirst.js": [
		10598,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		9245,
		3215,
		8607,
		598
	],
	"./Dashboard/SysPermission/SysPermissionSecond": [
		62022,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		8881,
		9245,
		3215,
		8607,
		2022
	],
	"./Dashboard/SysPermission/SysPermissionSecond.js": [
		62022,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		8881,
		9245,
		3215,
		8607,
		2022
	],
	"./Dashboard/UserDuty/UserDutyFirst": [
		52871,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2871
	],
	"./Dashboard/UserDuty/UserDutyFirst.js": [
		52871,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2871
	],
	"./Dashboard/UserDuty/UserDutySecond": [
		4697,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		2630,
		8881,
		9976,
		9245,
		3215,
		8607,
		4697
	],
	"./Dashboard/UserDuty/UserDutySecond.js": [
		4697,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		2630,
		8881,
		9976,
		9245,
		3215,
		8607,
		4697
	],
	"./Dashboard/UserLevel/UserLevelFirst": [
		36149,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		1093,
		9245,
		3215,
		8607,
		2981,
		6149
	],
	"./Dashboard/UserLevel/UserLevelFirst.js": [
		36149,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		1093,
		9245,
		3215,
		8607,
		2981,
		6149
	],
	"./Dashboard/UserLevel/UserLevelSecond": [
		69460,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		2630,
		8881,
		9245,
		3215,
		8607,
		9460
	],
	"./Dashboard/UserLevel/UserLevelSecond.js": [
		69460,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		2630,
		8881,
		9245,
		3215,
		8607,
		9460
	],
	"./Lite/BasicSetting/AccountEdit": [
		7385,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		9245,
		3215,
		8607,
		2981,
		2604,
		7385
	],
	"./Lite/BasicSetting/AccountEdit.js": [
		7385,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9438,
		1400,
		9245,
		3215,
		8607,
		2981,
		2604,
		7385
	],
	"./Lite/BasicSetting/AccountList": [
		14650,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3074,
		9245,
		3215,
		8607,
		2981,
		555
	],
	"./Lite/BasicSetting/AccountList.js": [
		14650,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3074,
		9245,
		3215,
		8607,
		2981,
		555
	],
	"./Lite/BasicSetting/CompanyFirst": [
		16089,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6089
	],
	"./Lite/BasicSetting/CompanyFirst.js": [
		16089,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6089
	],
	"./Lite/BasicSetting/CompanySecond": [
		48388,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		2319,
		8388
	],
	"./Lite/BasicSetting/CompanySecond.js": [
		48388,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		2319,
		8388
	],
	"./Lite/BasicSetting/WarehouseFirst": [
		7978,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7978
	],
	"./Lite/BasicSetting/WarehouseFirst.js": [
		7978,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7978
	],
	"./Lite/BasicSetting/WarehouseSecond": [
		70671,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6144,
		671
	],
	"./Lite/BasicSetting/WarehouseSecond.js": [
		70671,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6144,
		671
	],
	"./Lite/Commodity/CommodityListFirst": [
		18803,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		1405,
		9245,
		3215,
		8607,
		2981,
		4144,
		8803
	],
	"./Lite/Commodity/CommodityListFirst.js": [
		18803,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		1405,
		9245,
		3215,
		8607,
		2981,
		4144,
		8803
	],
	"./Lite/Commodity/CommodityListSecond": [
		20491,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		8881,
		6441,
		1669,
		9245,
		3215,
		8607,
		1952,
		491
	],
	"./Lite/Commodity/CommodityListSecond.js": [
		20491,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		8881,
		6441,
		1669,
		9245,
		3215,
		8607,
		1952,
		491
	],
	"./Lite/Commodity/CommoditySortFirst": [
		1239,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		9438,
		1400,
		3957,
		9245,
		3215,
		8607,
		4481,
		1239
	],
	"./Lite/Commodity/CommoditySortFirst.js": [
		1239,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		9438,
		1400,
		3957,
		9245,
		3215,
		8607,
		4481,
		1239
	],
	"./Lite/Commodity/StockPutInFirst": [
		43547,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		3398,
		9245,
		3215,
		8607,
		3547
	],
	"./Lite/Commodity/StockPutInFirst.js": [
		43547,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		3398,
		9245,
		3215,
		8607,
		3547
	],
	"./Lite/Commodity/StockPutInSecond": [
		92484,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		2484
	],
	"./Lite/Commodity/StockPutInSecond.js": [
		92484,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		2484
	],
	"./Lite/CustomerManagement/CustomerFirst": [
		49486,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		8655,
		9486
	],
	"./Lite/CustomerManagement/CustomerFirst.js": [
		49486,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		8655,
		9486
	],
	"./Lite/CustomerManagement/CustomerLevelFirst": [
		80370,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2737,
		370
	],
	"./Lite/CustomerManagement/CustomerLevelFirst.js": [
		80370,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2737,
		370
	],
	"./Lite/CustomerManagement/CustomerLevelSecond": [
		68628,
		7,
		8628
	],
	"./Lite/CustomerManagement/CustomerLevelSecond.js": [
		68628,
		7,
		8628
	],
	"./Lite/CustomerManagement/CustomerSecond": [
		89543,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		7813,
		9543
	],
	"./Lite/CustomerManagement/CustomerSecond.js": [
		89543,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		7813,
		9543
	],
	"./Lite/Index/Home": [
		76888,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		2112,
		9245,
		3215,
		8607,
		2981,
		1380,
		6888
	],
	"./Lite/Index/Home.js": [
		76888,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		2112,
		9245,
		3215,
		8607,
		2981,
		1380,
		6888
	],
	"./Lite/InventoryControl/InvAdjustFirst": [
		65101,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8103,
		5101
	],
	"./Lite/InventoryControl/InvAdjustFirst.js": [
		65101,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8103,
		5101
	],
	"./Lite/InventoryControl/InvAdjustSecond": [
		46671,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		6671
	],
	"./Lite/InventoryControl/InvAdjustSecond.js": [
		46671,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		6671
	],
	"./Lite/InventoryControl/StockReport": [
		3014,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337,
		3014
	],
	"./Lite/InventoryControl/StockReport.js": [
		3014,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337,
		3014
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst": [
		91821,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9438,
		1400,
		9741,
		9245,
		3215,
		8607,
		2981,
		3322,
		1821
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst.js": [
		91821,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9438,
		1400,
		9741,
		9245,
		3215,
		8607,
		2981,
		3322,
		1821
	],
	"./Lite/OrderManagement/OrderFirst": [
		87899,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		27,
		7899
	],
	"./Lite/OrderManagement/OrderFirst.js": [
		87899,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		27,
		7899
	],
	"./Lite/OrderManagement/OrderPickingFirst": [
		83314,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		6577,
		3314
	],
	"./Lite/OrderManagement/OrderPickingFirst.js": [
		83314,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		6577,
		3314
	],
	"./Lite/OrderManagement/OrderReturnFirst": [
		31725,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		9340,
		1725
	],
	"./Lite/OrderManagement/OrderReturnFirst.js": [
		31725,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		9340,
		1725
	],
	"./Lite/OrderManagement/OrderReturnSecond": [
		57377,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		2130,
		7377
	],
	"./Lite/OrderManagement/OrderReturnSecond.js": [
		57377,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		2130,
		7377
	],
	"./Lite/OrderManagement/OrderSecond": [
		10994,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		6441,
		9245,
		3215,
		8607,
		2981,
		5602,
		994
	],
	"./Lite/OrderManagement/OrderSecond.js": [
		10994,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		6441,
		9245,
		3215,
		8607,
		2981,
		5602,
		994
	],
	"./Lite/PromotionSetting/PromoAllFirst": [
		68543,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		1093,
		9245,
		3215,
		8607,
		2981,
		6528,
		8412,
		8543
	],
	"./Lite/PromotionSetting/PromoAllFirst.js": [
		68543,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		1093,
		9245,
		3215,
		8607,
		2981,
		6528,
		8412,
		8543
	],
	"./Lite/PromotionSetting/PromoDIY": [
		70191,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		8845,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		9982,
		8881,
		6441,
		7606,
		2353,
		9245,
		3215,
		6528,
		149,
		191
	],
	"./Lite/PromotionSetting/PromoDIY.tsx": [
		70191,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		8845,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		9982,
		8881,
		6441,
		7606,
		2353,
		9245,
		3215,
		6528,
		149,
		191
	],
	"./Lite/PromotionSetting/PromotionAllSecond": [
		1711,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		2353,
		9245,
		3215,
		8607,
		2981,
		6528,
		4403,
		1711
	],
	"./Lite/PromotionSetting/PromotionAllSecond.js": [
		1711,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		2353,
		9245,
		3215,
		8607,
		2981,
		6528,
		4403,
		1711
	],
	"./Lite/SellSetting/SellSettingFirst": [
		93249,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		4163,
		3249
	],
	"./Lite/SellSetting/SellSettingFirst.js": [
		93249,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		4163,
		3249
	],
	"./Lite/SellSetting/SellSettingSecond": [
		42652,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		9741,
		9245,
		3215,
		8607,
		2981,
		8191,
		2652
	],
	"./Lite/SellSetting/SellSettingSecond.js": [
		42652,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		9741,
		9245,
		3215,
		8607,
		2981,
		8191,
		2652
	],
	"./Stock/Commodity/CommodityListFirst": [
		84144,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		1405,
		9245,
		3215,
		8607,
		2981,
		4144
	],
	"./Stock/Commodity/CommodityListFirst.js": [
		84144,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		1405,
		9245,
		3215,
		8607,
		2981,
		4144
	],
	"./Stock/Commodity/CommodityListSecond": [
		61952,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		8881,
		6441,
		1669,
		9245,
		3215,
		8607,
		1952
	],
	"./Stock/Commodity/CommodityListSecond.js": [
		61952,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		8881,
		6441,
		1669,
		9245,
		3215,
		8607,
		1952
	],
	"./Stock/Commodity/CommoditySortFirst": [
		4481,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		9438,
		1400,
		3957,
		9245,
		3215,
		8607,
		4481
	],
	"./Stock/Commodity/CommoditySortFirst.js": [
		4481,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		9438,
		1400,
		3957,
		9245,
		3215,
		8607,
		4481
	],
	"./Stock/Commodity/CommoditySortSecond": [
		13216,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9198,
		9245,
		3215,
		8607,
		3216
	],
	"./Stock/Commodity/CommoditySortSecond.js": [
		13216,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9198,
		9245,
		3215,
		8607,
		3216
	],
	"./Stock/Commodity/CommoditySortThird": [
		7512,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		3827,
		9245,
		8607,
		7512
	],
	"./Stock/Commodity/CommoditySortThird.js": [
		7512,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		3827,
		9245,
		8607,
		7512
	],
	"./Stock/Company/CompanyFirst": [
		99090,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		9090
	],
	"./Stock/Company/CompanyFirst.js": [
		99090,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		9090
	],
	"./Stock/Company/CompanySecond": [
		22319,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		2319
	],
	"./Stock/Company/CompanySecond.js": [
		22319,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		2319
	],
	"./Stock/Import/ImportListFirst": [
		91861,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9438,
		1400,
		1093,
		9466,
		9245,
		3215,
		8607,
		1861
	],
	"./Stock/Import/ImportListFirst.js": [
		91861,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9438,
		1400,
		1093,
		9466,
		9245,
		3215,
		8607,
		1861
	],
	"./Stock/Import/ImportListSecond": [
		50955,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		955
	],
	"./Stock/Import/ImportListSecond.js": [
		50955,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		955
	],
	"./Stock/Index/Home": [
		90985,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		985
	],
	"./Stock/Index/Home.js": [
		90985,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		1153,
		4014,
		8845,
		6416,
		3020,
		9245,
		3215,
		8607,
		985
	],
	"./Stock/InventoryControl/InvAdjustFirst": [
		28103,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8103
	],
	"./Stock/InventoryControl/InvAdjustFirst.js": [
		28103,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8103
	],
	"./Stock/InventoryControl/InvAdjustSecond": [
		25683,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		5683
	],
	"./Stock/InventoryControl/InvAdjustSecond.js": [
		25683,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		5683
	],
	"./Stock/InventoryControl/InvScrapFirst": [
		13454,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3454
	],
	"./Stock/InventoryControl/InvScrapFirst.js": [
		13454,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3454
	],
	"./Stock/InventoryControl/InvScrapSecond": [
		2089,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2089
	],
	"./Stock/InventoryControl/InvScrapSecond.js": [
		2089,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2089
	],
	"./Stock/InventoryControl/InvTransferFirst": [
		21219,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		1219
	],
	"./Stock/InventoryControl/InvTransferFirst.js": [
		21219,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		1219
	],
	"./Stock/InventoryControl/InvTransferSecond": [
		27197,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7197
	],
	"./Stock/InventoryControl/InvTransferSecond.js": [
		27197,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7197
	],
	"./Stock/Purchase/PurchaseListFirst": [
		13693,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		3693
	],
	"./Stock/Purchase/PurchaseListFirst.js": [
		13693,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		3693
	],
	"./Stock/Purchase/PurchaseListSecond": [
		35210,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		3398,
		836,
		9245,
		3215,
		8607,
		5210
	],
	"./Stock/Purchase/PurchaseListSecond.js": [
		35210,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		3398,
		836,
		9245,
		3215,
		8607,
		5210
	],
	"./Stock/Stock/StockListFirst": [
		56835,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		6835
	],
	"./Stock/Stock/StockListFirst.js": [
		56835,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		6835
	],
	"./Stock/Stock/StockListSecond": [
		82862,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2862
	],
	"./Stock/Stock/StockListSecond.js": [
		82862,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		2862
	],
	"./Stock/StockReport/StockReport": [
		5227,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337,
		5227
	],
	"./Stock/StockReport/StockReport.js": [
		5227,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337,
		5227
	],
	"./Stock/Warehouse/WarehouseFirst": [
		77382,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7382
	],
	"./Stock/Warehouse/WarehouseFirst.js": [
		77382,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		9245,
		3215,
		8607,
		2981,
		7382
	],
	"./Stock/Warehouse/WarehouseSecond": [
		66144,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6144
	],
	"./Stock/Warehouse/WarehouseSecond.js": [
		66144,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		6144
	],
	"./WebContent/CustomerManagement/BonusImportLog": [
		23046,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3046
	],
	"./WebContent/CustomerManagement/BonusImportLog.js": [
		23046,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3046
	],
	"./WebContent/CustomerManagement/CustomerFirst": [
		48655,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		8655
	],
	"./WebContent/CustomerManagement/CustomerFirst.js": [
		48655,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		8655
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst": [
		22737,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2737
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst.js": [
		22737,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		1386,
		8881,
		9245,
		3215,
		8607,
		2737
	],
	"./WebContent/CustomerManagement/CustomerLevelSecond": [
		14216,
		7,
		4216
	],
	"./WebContent/CustomerManagement/CustomerLevelSecond.js": [
		14216,
		7,
		4216
	],
	"./WebContent/CustomerManagement/CustomerSecond": [
		57813,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		7813
	],
	"./WebContent/CustomerManagement/CustomerSecond.js": [
		57813,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		7813
	],
	"./WebContent/Index/Home": [
		28768,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		2112,
		9245,
		3215,
		8607,
		2981,
		1380
	],
	"./WebContent/Index/Home.js": [
		28768,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		2112,
		9245,
		3215,
		8607,
		2981,
		1380
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail": [
		90677,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		677
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail.js": [
		90677,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		677
	],
	"./WebContent/LogisticsSetting/LogisticsFirst": [
		63159,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		3159
	],
	"./WebContent/LogisticsSetting/LogisticsFirst.js": [
		63159,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		3159
	],
	"./WebContent/LogisticsSetting/LogisticsFirst.tsx": [
		81408,
		7,
		1408
	],
	"./WebContent/LogisticsSetting/LogisticsSecond": [
		12469,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		610,
		9245,
		3215,
		8607,
		2469
	],
	"./WebContent/LogisticsSetting/LogisticsSecond.js": [
		12469,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		8881,
		610,
		9245,
		3215,
		8607,
		2469
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst": [
		43322,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9438,
		1400,
		9741,
		9245,
		3215,
		8607,
		2981,
		3322
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst.js": [
		43322,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9438,
		1400,
		9741,
		9245,
		3215,
		8607,
		2981,
		3322
	],
	"./WebContent/OrderManagement/OrderFirst": [
		10027,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		27
	],
	"./WebContent/OrderManagement/OrderFirst.js": [
		10027,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		27
	],
	"./WebContent/OrderManagement/OrderPickingFirst": [
		36577,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		6577
	],
	"./WebContent/OrderManagement/OrderPickingFirst.js": [
		36577,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		6577
	],
	"./WebContent/OrderManagement/OrderReturnFirst": [
		99340,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		9340
	],
	"./WebContent/OrderManagement/OrderReturnFirst.js": [
		99340,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		9340
	],
	"./WebContent/OrderManagement/OrderReturnSecond": [
		92130,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		2130
	],
	"./WebContent/OrderManagement/OrderReturnSecond.js": [
		92130,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		9245,
		3215,
		8607,
		2981,
		2130
	],
	"./WebContent/OrderManagement/OrderSecond": [
		65602,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		6441,
		9245,
		3215,
		8607,
		2981,
		5602
	],
	"./WebContent/OrderManagement/OrderSecond.js": [
		65602,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		539,
		3398,
		6441,
		9245,
		3215,
		8607,
		2981,
		5602
	],
	"./WebContent/OrderManagement/OrderShipFirst": [
		42088,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2630,
		8881,
		4898,
		9245,
		3215,
		8607,
		2088
	],
	"./WebContent/OrderManagement/OrderShipFirst.js": [
		42088,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2630,
		8881,
		4898,
		9245,
		3215,
		8607,
		2088
	],
	"./WebContent/OrderManagement/old_OrderFirst": [
		17326,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		7326
	],
	"./WebContent/OrderManagement/old_OrderFirst.js": [
		17326,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		3398,
		6441,
		9438,
		1400,
		1093,
		9245,
		3215,
		8607,
		8816,
		7326
	],
	"./WebContent/OrderMessage/OrderMessageFirst": [
		82157,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		2466,
		9245,
		3215,
		8607,
		5458,
		1071
	],
	"./WebContent/OrderMessage/OrderMessageFirst.js": [
		82157,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		2466,
		9245,
		3215,
		8607,
		5458,
		1071
	],
	"./WebContent/PaymentSetting/PaymentFirst": [
		34791,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		4791
	],
	"./WebContent/PaymentSetting/PaymentFirst.js": [
		34791,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		9245,
		3215,
		8607,
		2981,
		4791
	],
	"./WebContent/PromotionSetting/PromoAllFirst": [
		92904,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		1093,
		9245,
		3215,
		8607,
		2981,
		6528,
		8412
	],
	"./WebContent/PromotionSetting/PromoAllFirst.js": [
		92904,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		1093,
		9245,
		3215,
		8607,
		2981,
		6528,
		8412
	],
	"./WebContent/PromotionSetting/PromoDIY": [
		44977,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		8845,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		9982,
		8881,
		6441,
		7606,
		2353,
		9245,
		3215,
		6528,
		149
	],
	"./WebContent/PromotionSetting/PromoDIY.tsx": [
		44977,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		8845,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		9982,
		8881,
		6441,
		7606,
		2353,
		9245,
		3215,
		6528,
		149
	],
	"./WebContent/PromotionSetting/PromotionAllSecond": [
		74403,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		2353,
		9245,
		3215,
		8607,
		2981,
		6528,
		4403
	],
	"./WebContent/PromotionSetting/PromotionAllSecond.js": [
		74403,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		7606,
		2353,
		9245,
		3215,
		8607,
		2981,
		6528,
		4403
	],
	"./WebContent/Report/AdjustDetailReport": [
		56761,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		6761
	],
	"./WebContent/Report/AdjustDetailReport.js": [
		56761,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		6761
	],
	"./WebContent/Report/CustomerReport": [
		70531,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		531
	],
	"./WebContent/Report/CustomerReport.js": [
		70531,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		531
	],
	"./WebContent/Report/OrderRevenue": [
		35937,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		5937
	],
	"./WebContent/Report/OrderRevenue.js": [
		35937,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		5937
	],
	"./WebContent/Report/OrderSaleDetail": [
		45174,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		5174
	],
	"./WebContent/Report/OrderSaleDetail.js": [
		45174,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		5174
	],
	"./WebContent/Report/OrderSaleSummary": [
		38502,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8502
	],
	"./WebContent/Report/OrderSaleSummary.js": [
		38502,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		8502
	],
	"./WebContent/Report/PromotionReport": [
		73938,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3938
	],
	"./WebContent/Report/PromotionReport.js": [
		73938,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3938
	],
	"./WebContent/Report/ScrapDetailReport": [
		23367,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3367
	],
	"./WebContent/Report/ScrapDetailReport.js": [
		23367,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		3367
	],
	"./WebContent/Report/StockReport": [
		33337,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337
	],
	"./WebContent/Report/StockReport.js": [
		33337,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		3337
	],
	"./WebContent/Report/StockTransferReport": [
		52061,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		2061
	],
	"./WebContent/Report/StockTransferReport.js": [
		52061,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		2411,
		2630,
		6174,
		1985,
		9982,
		9245,
		3215,
		8607,
		2061
	],
	"./WebContent/SellSetting/SellSettingFirst": [
		54163,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		4163
	],
	"./WebContent/SellSetting/SellSettingFirst.js": [
		54163,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		4014,
		8845,
		6416,
		3020,
		6314,
		9245,
		3215,
		8607,
		4163
	],
	"./WebContent/SellSetting/SellSettingSecond": [
		28191,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		9741,
		9245,
		3215,
		8607,
		2981,
		8191
	],
	"./WebContent/SellSetting/SellSettingSecond.js": [
		28191,
		9,
		6546,
		2697,
		2744,
		5942,
		4896,
		3006,
		1153,
		7548,
		4014,
		8845,
		6416,
		3020,
		6314,
		1386,
		2411,
		2630,
		6174,
		1985,
		9982,
		8881,
		539,
		6441,
		9741,
		9245,
		3215,
		8607,
		2981,
		8191
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 39679;
module.exports = webpackAsyncContext;